module.exports = new __parcel__URL__("rogue.415138ed.png").toString();